import { createBrowserHistory } from 'history';
import devStore from './configStore.dev';
import prodStore from './configStore.prod';

export const history = createBrowserHistory();
export default process.env.REACT_APP_STAGE === 'production'
  ? prodStore(history)
  : devStore(history);
